import React from 'react';

import { ArrayFieldTemplateProps, RJSFSchema } from '@rjsf/utils';

import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Stack, Typography } from '@mui/material';

/**
 * SimpleArrayFieldTemplate - A simplified RJSF ArrayFieldTemplate without
 * the heavy Paper/box-shadow styling of the default MUI template.
 *
 * Features:
 * - Clean, minimal styling
 * - Add/Remove/Move buttons (handled by ArrayFieldItemTemplate)
 * - No Paper wrapper or box shadows
 *
 * Note: In RJSF v6, items are React elements that include their own controls.
 * The template just needs to render them in the desired layout.
 */

export default function SimpleArrayFieldTemplate({
  items,
  canAdd,
  onAddClick,
  title,
  schema,
}: ArrayFieldTemplateProps<unknown, RJSFSchema>) {
  return (
    <Box sx={{ mb: 4, mt: 4 }}>
      {title && (
        <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 500 }}>
          {title}
        </Typography>
      )}

      <Stack spacing={1}>
        {items.map((item) => (
          <React.Fragment key={item.key}>{item}</React.Fragment>
        ))}
      </Stack>

      {canAdd && (
        <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={onAddClick} sx={{ mt: 1 }}>
          Add {schema.items?.['title'] || 'item'}
        </Button>
      )}
    </Box>
  );
}
